<template>
  <div class="flexout" style="flex-direction: column;height:100%;">
    <div style="height:8rem;width:100%;">
      <div class="flexout"><span class="text">24小时环境监测</span></div> 
      <div class="task_tab tab_box">
        <div :class="[taskTabIndex==index?'task_tabActive':'task_tabOne']" @click="changeTaskTab(index)" v-for="(item,index) in tabArr">{{item.name}}</div>
      </div>
    </div>
    <div class="zhe_box">
      <div class="martop15" v-for="(item,ind) in trendData" :key="ind" v-if="item.now != null && item.now != 0">
        <div class="colorText">{{item.name}} {{getAfter(item.now)}}</div>
        <div class="colorText">平均{{getAfter(item.avg)}} 最高{{getAfter(item.max)}} 最低{{getAfter(item.min)}}</div>
        <div class="echartFlowScience">
          <LineChart3 :chartData="item.list"></LineChart3>
        </div>
      </div>
    </div>     
  </div>
</template>
<script>
import { getEnvRealtimeData, getEnvInfoData } from '../../../apis/src/Query';
import LineChart3 from "@/views/echart/LineEchart3";
import moment from 'moment';
 export default {
    name:"ScienceRight",
    componentName:"ScienceRight",
    components: { LineChart3 },
    data() {
      return {
        tabArr:[
          {
            name:"温度",
            type:"temp",
            after:"℃"
          },
          {
            name:"湿度",
            type:"humidity",
            after:"%"
          },
          {
            name:"气压",
            type:"pressure",
            after:"kPa"
          },
          {
            name:"负氧离子",
            type:"noi",
            after:"个/cm³"
          },
          {
            name:"PM2.5",
            type:"pm25",
            after:"μg/cm³"
          },
          {
            name:"PM10",
            type:"pm10",
            after:"μg/cm³"
          },
        ],
        taskTabIndex:0,
        trendData:[],
        // 监测点列表
        EnvPointList:[]
      }
    },
    created() {      
      this.getPointList(this.tabArr[0].type);
    },
    methods: {
      // 获取监测点列表
      getPointList(type){
        getEnvRealtimeData().then(res => {
          if(res.data){
            this.EnvPointList = res.data.map(item => {
              return {
                deviceId: item.deviceId,
                name: item.siteName,
                temp: item.temperature,
                humidity: item.atmosphericHumidity,
                pressure: item.airPressure,
                noi: item.negativeOxideIon,
                pm25: item.pm25,
                pm10: item.pm10
              }
            });
            this.getLineChartData(type);
          }
        });
      },
      // 获取图表数据：环境监测
      async getLineChartData(type){
        // 图表数据
        this.trendData = [];
        for(let i=0; i < this.EnvPointList.length; i++){
          await getEnvInfoData({ 
            districtCode: '652302',
            startTime: moment(new Date().getTime() - 24*60*60*1000).format('YYYY-MM-DD HH:00:00'),
            envIdxName: type, 
            timeType: 'hour',
            deviceId: this.EnvPointList[i].deviceId
          }).then(res => {
            let data = res.data;
            // 平均值
            let avgArr = data.filter(item => item.avgVal != 0).map(item => item.avgVal);
            let avg = avgArr.reduce((total,n) => total + n, 0) / avgArr.length;
            // 最大值
            let max = Math.max.apply(null,data.filter(item => item.maxVal != 0).map(item => item.maxVal));
            // 最小值
            let min = Math.min.apply(null,data.filter(item => item.minVal != 0).map(item => item.minVal));
            this.trendData.push({
              name: this.EnvPointList[i].name,
              now: this.EnvPointList[i][type],
              max: max == 'Infinity' ? '--' : max,
              min: min == 'Infinity' ? '--' : min,
              avg: avg == 'NaN' ? '--' : avg.toFixed(2),
              list: {
                days: data.map(item => moment(item.dataTime).format('MM-DD HH:mm:ss')),
                data: data.map(item => item.avgVal)
              }
            });
          });
        }
      },
      // 格式化数据
      getAfter(val){
        if(val=="undefined"||val=="null"){
          return "";
        }else{
          let index = this.taskTabIndex;
          return val + this.tabArr[index].after
        }
      },
      // 点击面板
      changeTaskTab(index){
        this.taskTabIndex = index;
        let clickType = this.tabArr[index].type;
        this.getPointList(clickType);
      },
    }
  };
</script>
<style lang="scss" scoped>
.flexout{
    display:flex;
    align-items:center;
    justify-content:flex-start;    
    .line{
      display: inline-block;
      width:4px;
      height:22px;
      background: #00c6ff;
      margin-right:10px; 
    }
    .text{
      font-size: 18px;
      line-height: 26px;
      color: #23c3ff;
    }
}
.tab_box{ 
    display:flex;
    align-items: center;
}
.betw{
   justify-content: space-between; 
}
.textStart{
  justify-content: flex-start;
}
.topOne{ 
    width:41.6%;
    height:auto;
    line-height: 50px;  
    font-size: 0.2rem;
    text-align: right;
    padding-right:2.6rem;
    box-sizing: border-box;
    cursor: pointer;
}
.task_tabActive{
    font-weight:bold;
    font-size:1.4rem;
    line-height: 24px;
    letter-spacing: 0px;
    color: #23c3ff;
    border-bottom: 2px solid #00c6ff;
    cursor: pointer;
    margin-right:10px;
}
.task_tabOne{
   font-weight:bold;
   font-size:1.4rem;
   line-height: 24px;
   letter-spacing: 0px;
   color: #e4f7ff;
   opacity: 0.5;
   cursor: pointer;
   margin-right:10px;
 }
.icon1{
  width: 38px;
	height: 24px;
	border: solid 1px #2bc2ff;
  text-align: center;
  line-height: 24px;
  margin-right:10px;
}
.marginr15{
  margin-right:15px;
}
.icon2{
	border: solid 1px #ffdc4e;
  color: #ffdc4e;
}
.icon3{
	border: solid 1px #ff4e4e;
  color: #ff4e4e;
}
.colorText{
  font-weight: bold;
	font-size: 14px;
	line-height: 24px;
	letter-spacing: 0px;
	color: #2ac1ff;
}
.martop15{
  margin-top: 15px;
}
.echartFlowScience{
  height:120px;
}
.zhe_box{
  width:100%;
  flex:1;
  overflow:auto;
}
.zhe_box::-webkit-scrollbar {
    display: none;
}
</style>